export default "__VITE_ASSET__CVgH1zOF__"